import store from '../store/store';
import { ReadingPaneState } from '../store/schema/ReadingPaneState';

export default function getReadingPaneState(): ReadingPaneState {
    return store.viewState;
}
